import BaseApi from "../../BaseApi";
import { headers } from "../../ApiSettings";

class Construction extends BaseApi {
  constructor() {
    super({ suffix: "Project" });
  }
  /**
   * @param {(KeyGroup: *,KeyUser: *,  IdProject: *}} data
   * @return {*}
   */
  getListUniteDesignerBuild(data) {
    return this.httpService.post("list-unit-designer-build-body", data, {
      headers,
    });
  }

  /**
   * post data to set-setting-tarahi
   * @param {{KeyGroup: * , KeyUser:* ,ModelSetting: *,NameUnit:* ,BreakW: *,BreakH: *, ZehvarBaranOneRail: *,ZehvarBaranTowRail: *,ZehvarBaranFixOneRail: *,ZehvarBaranBottom: *,ZehvarBaranAll: *,SizeFontDesigner: *,LimitCouple: *,LimitMulion: *,LimitGuidLine: *,GlassCalc: *,NetCalc: *,CoverWaterFrame: *,CoverWaterMulion: *,CoverWaterTop: *,CoverWaterbot: *,MinOneCoveWater: *,MaxOneCoveWater : *,MinTwoCoveWater: *,MaxTwoCoveWater, *, DistinctTwoCoveWater: *, IsShowNameUnitOptimal: * , IsShowNameProjectOptimal: *, IsShowHandleOptimal: * , IsShowLolaOptimal: *, IsShowCoverWaterOptimal: *, LenIsWeaste: *, ThickProfile: *, ThickIron: *, LenIsWeasteIron: * , CountGlassFix: *, CountGlassPop: *, CountMinScrewIron: * ,CountBetweenScrowIron: * , CostArc: *, CostAngle: *, AddressFactor: *, EmailFactor: *, FooterFactor: * ,HeaderFactor: *, HeaderSloganFactor: * ,LogoFactor: *, TellFactor: *, WebFactor: *  }} data
   * @return {*}
   */
  postInsertBuildUnitString(data) {
    return this.httpService.post("build-unit-string", data, { headers });
  }

  postSakhtUnitJson(data) {
    return this.httpService.post("sakht-unit-json", data, { headers });
  }
}

const ConstructionServices = new Construction();
export default ConstructionServices;
